import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQrcode, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { usePageTitle } from '../hooks/usePageTitle';

const MobileErrorPage = ({ error }) => {

  usePageTitle('Continuá tu compra');

  const getErrorMessage = () => {
    switch (error) {
      case 'token_expired':
        return {
          title: 'Tu sesión expiró',
          message: 'Tu sesión caducó. Pedile a tu vendedor que genere un nuevo código QR desde la computadora para continuar.'
        };
      case 'invalid_token':
        return {
          title: 'Enlace inválido',
          message: 'Este enlace ya no sirve. Pedile a tu vendedor un nuevo código QR desde la computadora.'
        };
      default:
        return {
          title: 'No pudimos iniciar',
          message: 'Algo salió mal. Pedile a tu vendedor un nuevo código QR desde la computadora para continuar.'
        };
    }
  };

  const { title, message } = getErrorMessage();

  return (
    <div className="container">
      <div className="text-center mt-5">
        <div className="error-icon mb-4">
          <FontAwesomeIcon 
            icon={faExclamationTriangle} 
            className="text-warning"
            style={{ fontSize: '3rem' }}
          />
        </div>
        <h4 className="mb-3">{title}</h4>
        <p className="text-muted mb-4">{message}</p>
        <div className="qr-hint mt-4">
          <FontAwesomeIcon 
            icon={faQrcode} 
            className="text-primary mb-2"
            style={{ fontSize: '2rem' }}
          />
          <p className="small text-muted">
            Escaneá un nuevo código QR para seguir con tu compra
          </p>
        </div>
      </div>
    </div>
  );
};

export default MobileErrorPage; 